module.exports = __webpack_public_path__ + "img/contact.54b82876.png";